import React, { MouseEvent } from 'react'
import { Box } from '@material-ui/core'
import { MARK_TYPE } from 'config/constants/preview'
import { ClipCreatorMarkType } from 'types/preview'
import { isNil } from 'lodash'
import classNames from 'classnames'
import { ReactComponent as MarkInIcon } from '~/assets/preview/mark_in.svg'

interface IProps {
  onClickMarkIcon: (markType: ClipCreatorMarkType, isResizer?: boolean) => (e: MouseEvent) => void
  markIn: number | null
  isDragging: boolean
}

export const LeftBound = ({ markIn, onClickMarkIcon, isDragging }: IProps) => (
  <>
    {!isNil(markIn)
      ? (
        <div
          onMouseDown={onClickMarkIcon(MARK_TYPE.IN, true)}
          className={classNames('clip-creator__bar-resizer clip-creator__bar-resizer_l', {
            draggable: isDragging,
          })}
        >
          <Box className="hidden-resizer hidden-resizer_l" />
          <MarkInIcon />
          <div className="clip-creator__transparent-remover clip-creator__transparent-remover_l" />
        </div>
      )
      : <Box width="2px" height="2px" />}
  </>
)
